import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import token from '../token/tokens';
import {Configurator} from '@spartacus/product-configurator/rulebased';

const ADD_TO_CART_URL_REGEX = /users\/[0-9a-z_]*\/carts\/[0-9a-z-]*\/entries\/ccpconfigurator/;
const UPDATE_CART_URL_REGEX = /users\/[0-9a-z_]*\/carts\/[0-9a-z-]*\/entries\/\d{1,2}\/ccpconfigurator/;

@Injectable()
export class CpsCampaignTrackingInterceptor implements HttpInterceptor {
  private campaignTrackingService = inject(token.optionalServices.CAMPAIGN_TRACKING_SERVICE_PROVIDER, {optional: true});

  intercept(request: HttpRequest<Configurator.AddToCartParameters>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isAddToCartCall(request) && !this.isUpdateCall(request)) {
      return next.handle(request);
    }
    this.extractCampaignAttributes(request.body as Configurator.AddToCartParameters);
    return next.handle(request);
  }

  private isAddToCartCall(request: HttpRequest<unknown>): boolean {
    return request.method === 'POST' && !!request.url.match(new RegExp(ADD_TO_CART_URL_REGEX));
  }

  private isUpdateCall(request: HttpRequest<unknown>): boolean {
    return request.method === 'PUT' && !!request.url.match(new RegExp(UPDATE_CART_URL_REGEX));
  }

  public extractCampaignAttributes(addToCartParameters: Configurator.AddToCartParameters): void {
    if (!addToCartParameters || !this.campaignTrackingService || !this.campaignTrackingService.getCampaignData()) {
      return;
    }
    if (!addToCartParameters.data) {
      addToCartParameters.data = [];
    }
    addToCartParameters.data['push']({
      type: 'marketingAttributes',
      value: JSON.stringify(
        this.campaignTrackingService.toCodeValuePair(this.campaignTrackingService.getCampaignData()),
      ),
    });
  }
}
